"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _TitleCard = _interopRequireDefault(require("01_core/components/layout/TitleCard"));
var _CButton = _interopRequireDefault(require("01_core/components/materials/CButton"));
var _CallAPI = require("01_core/components/system/CallAPI");
var _labelConsts = require("01_core/constants/labelConsts");
var _stringConsts = require("01_core/constants/stringConsts");
var _react = _interopRequireDefault(require("react"));
var _reactIntl = require("react-intl");
var _reactRedux = require("react-redux");
var _material = require("@mui/material");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * 機能利用不可画面.
 */
class KansaUnavailability extends _react.default.Component {
  render() {
    const {
      intl,
      history,
      titleLabelId
    } = this.props;

    // 戻るボタン
    const returnButton = /*#__PURE__*/_react.default.createElement(_CButton.default, {
      autoWidth: true,
      negative: true,
      onClick: () => {
        history.push(_stringConsts.STRING_CONSTS.ROOT_PATH);
      }
    }, intl.formatMessage({
      id: _labelConsts.LABEL.CORE_TO_RETURN_HOME
    }));
    return /*#__PURE__*/_react.default.createElement(_TitleCard.default, {
      title: intl.formatMessage({
        id: titleLabelId
      }),
      actions: [returnButton]
    }, /*#__PURE__*/_react.default.createElement(_material.CardContent, null, /*#__PURE__*/_react.default.createElement(_material.Typography, null, intl.formatMessage({
      id: _labelConsts.LABEL.KANSA_KANSA_UNAVAILABILITY
    }))));
  }
}
var _default = exports.default = (0, _reactRedux.connect)(null, null)((0, _reactIntl.injectIntl)((0, _CallAPI.withCallAPI)(KansaUnavailability)));